import React from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress, Alert, Box } from '@mui/material';
import useApi from '../hooks/useApi';

const MetricCard = ({ label, value, isLoading }) => (
  <Card variant="outlined" sx={{ height: '100%', borderRadius: 3 }}>
    <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="overline" color="text.secondary">
        {label}
      </Typography>
      {isLoading ? (
        <CircularProgress size={24} />
      ) : (
        <Typography variant="h4" sx={{ mt: 0.25, fontWeight: 900, letterSpacing: -0.4 }}>
          {value ?? 0}
        </Typography>
      )}
    </CardContent>
  </Card>
);

const AppSheetStatusChangesSummary = ({ programName }) => {
  const { useAppSheetStatusChangeMetrics } = useApi();
  const { data, isLoading, error } = useAppSheetStatusChangeMetrics({ programName });

  if (error) {
    return <Alert severity="error">{error?.message || 'Failed to load AppSheet status metrics.'}</Alert>;
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, gap: 1, flexWrap: 'wrap' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 900 }}>
          AppSheet Status Changes
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <MetricCard label="Today" value={data?.today} isLoading={isLoading} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <MetricCard label="Last 7 days" value={data?.last7Days} isLoading={isLoading} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <MetricCard label="Last 30 days" value={data?.last30Days} isLoading={isLoading} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AppSheetStatusChangesSummary;
